import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ConversationItem from 'models/conversation_item';
import ItemContent from '../item_content';
import Metadata from 'components/customer/conversation_history/conversation_items_v2/metadata/metadata';
import RuleLink from '../metadata/rule_link';

export default function RuleDisabledLoop({ item }) {
  const { t } = useTranslation();
  const ruleLink = <RuleLink ruleId={item.content.ruleId}>{t('Rule')}</RuleLink>;

  return (
    <ItemContent isAuditItem item={item}>
      <Metadata subject={ruleLink} text={t('deactivated because it fired multiple times')} timestamp={item.timestamp} />
    </ItemContent>
  );
}

RuleDisabledLoop.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};
